import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import extractText from 'flarum/common/utils/extractText';
import { readDisplayText } from '../utils/normalizeConversation.js';
import resolveLiveHeaderStatus from '../utils/resolveLiveHeaderStatus.js';
import buildShellHeaderOverflowItems, { mergeHeaderOverflowItems } from '../utils/buildShellHeaderOverflowItems.js';

/**
 * Shell-owned conversation chrome. Direct and Live share back | title | ⋮.
 * Providers may append overflow items; they do not decide whether ⋮ exists.
 */
export default class MessagesConversationHeader extends Component {
  view() {
    const {
      kind,
      conversation,
      onBack,
      onAllMessages,
      providerOverflowItems = null
    } = this.attrs;
    const title = resolveHeaderTitle(kind, conversation);
    const liveStatus = resolveLiveHeaderStatus(kind, conversation);
    const isGeneralLive = kind === 'live' && conversation?.sourceId === 'community-general-live';
    const menuLabel = extractText(app.translator.trans('flatrate-messaging-ui.forum.page.conversation_menu'));
    const shellItems = buildShellHeaderOverflowItems({
      onBack: onAllMessages || onBack
    });
    const items = mergeHeaderOverflowItems(shellItems, providerOverflowItems).toArray().filter(Boolean);
    return m("header", {
      className: 'MessagesConversationHeader' + (kind ? ` MessagesConversationHeader--${kind}` : '') + (isGeneralLive ? ' MessagesConversationHeader--generalLive' : '')
    }, m(Button, {
      className: "Button Button--icon Button--flat MessagesConversationHeader-back",
      icon: "fas fa-arrow-left",
      "aria-label": app.translator.trans('flatrate-messaging-ui.forum.page.back'),
      onclick: () => {
        if (typeof onBack === 'function') onBack();
      }
    }), m("div", {
      className: "MessagesConversationHeader-main"
    }, isGeneralLive ? m("div", {
      className: "MessagesConversationHeader-generalCopy"
    }, m("h2", {
      className: "MessagesConversationHeader-title"
    }, "FlatRate.wiki"), m("div", {
      className: "MessagesConversationHeader-generalLiveStatus",
      "aria-label": generalLiveStatusLabel(liveStatus)
    }, m("span", null, "PUBLIC"), m("i", {
      className: "fas fa-globe MessagesConversationHeader-liveGlobe",
      "aria-hidden": "true"
    }), m("span", null, "LIVE"), liveStatus && liveStatus.count != null ? m("span", {
      className: "MessagesConversationHeader-liveCount"
    }, liveStatus.count) : null)) : m('[', null, conversation?.avatarUrl ? m("img", {
      className: "MessagesConversationHeader-avatar",
      src: conversation.avatarUrl,
      alt: ""
    }) : m("span", {
      className: "MessagesConversationHeader-icon",
      "aria-hidden": "true"
    }, m("i", {
      className: conversation?.icon || (kind === 'live' ? 'fas fa-comments' : 'fas fa-user')
    })), m("div", {
      className: "MessagesConversationHeader-copy"
    }, m("h2", {
      className: "MessagesConversationHeader-title"
    }, title), liveStatus ? m("div", {
      className: "MessagesConversationHeader-liveStatus"
    }, m("span", null, liveStatus.privacy), m("i", {
      className: "fas fa-globe MessagesConversationHeader-liveGlobe",
      "aria-hidden": "true"
    }), m("span", null, "LIVE"), liveStatus.count != null ? m("span", {
      className: "MessagesConversationHeader-liveCount"
    }, liveStatus.count) : null) : null))), m(Dropdown, {
      className: "MessagesConversationHeader-overflow",
      buttonClassName: "Button Button--icon Button--flat MessagesConversationHeader-overflowToggle",
      menuClassName: "Dropdown-menu--right",
      icon: "fas fa-ellipsis-v",
      caretIcon: null,
      label: menuLabel,
      accessibleToggleLabel: menuLabel
    }, items));
  }
}
function generalLiveStatusLabel(liveStatus) {
  if (liveStatus && liveStatus.count != null) {
    return `PUBLIC LIVE ${liveStatus.count}`;
  }
  return 'PUBLIC LIVE';
}
function resolveHeaderTitle(kind, conversation) {
  if (!conversation) {
    return kind === 'live' ? 'Live' : 'Conversation';
  }
  const title = readDisplayText(conversation.title);
  if (title) {
    return stripChatWithPrefix(title);
  }
  if (kind === 'live' && conversation.sourceId === 'community-general-live') {
    return 'FlatRate.wiki';
  }
  return readDisplayText(conversation.sourceId) || 'Conversation';
}
function stripChatWithPrefix(title) {
  const match = String(title).match(/^Chat with\s+(.+)$/i);
  return match ? match[1].trim() : title;
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/MessagesConversationHeader', MessagesConversationHeader);